import type { BlockCircleList } from 'types/block-circle-list';
import React from 'react';
import { Wrap, Paragraph } from '@leafwell/components';
import Figure from './figure';
import HeadingBody from './heading-body';
import { CircleListLine } from './circle-list-line';

const CircleList: React.FC<BlockCircleList> = ({
  title,
  subtitle,
  type,
  list,
}) => {
  const isCurved = type == 'curved';

  return (
    <Wrap>
      <div className="flex flex-col justify-center items-center">
        <HeadingBody className="col-span-full" level="3" title={title} />
        {subtitle && (
          <Paragraph size="medium" variant="medium" className="pt-2">
            {subtitle}
          </Paragraph>
        )}
        <div className="block relative pt-12 md:pt-8">
          <div className="grid md:grid-cols-3 gap-x-10 gap-y-14 relative">
            {list.map(({ title, content, icon }, index) => {
              return (
                <div
                  key={`circe-list-item-${index}`}
                  className={[
                    'flex flex-col items-center relative md:pt-0',
                    isCurved && index == 1 ? 'md:pt-16' : '',
                    !isCurved && index !== 0 ? 'pt-16' : 'pt-0',
                  ].join(' ')}
                >
                  <Figure {...icon} className="w-44 bg-white relative" />
                  <HeadingBody
                    className="col-span-full text-center pt-8 pb-3"
                    level="4"
                    title={title}
                  />
                  <Paragraph
                    size="medium"
                    dangerouslySetInnerHTML={{ __html: content }}
                    className="max-w-screen-sm leading-7 text-center"
                    tagName="p"
                  />
                </div>
              );
            })}
          </div>
          <CircleListLine
            type="left"
            variant={type}
            className={`absolute ${
              isCurved ? 'top-28' : 'top-1/3 translate-y-2'
            } left-64 -z-1 hidden lg:inline`}
          />
          <CircleListLine
            type="right"
            variant={type}
            className={`absolute ${
              isCurved ? 'top-28' : 'top-1/3 translate-y-2'
            } right-64 -z-1 hidden lg:inline`}
          />
        </div>
      </div>
    </Wrap>
  );
};

export default CircleList;
